import useCountUp from '../hooks/useCountUp';

export default function AnimatedNumber({ value, duration = 800 }) {
  const animated = useCountUp(value, duration);
  return <>{animated.toLocaleString()}</>;
}
